<template>
  <div
    class="bg-slate-50 dark:bg-slate-900 border-b dark:border-slate-800 py-2"
  >
    <div
      class="container mx-auto px-6 flex justify-between items-center text-xs text-slate-500 dark:text-slate-400"
    >
      <div class="flex gap-4">
        <span class="flex items-center gap-1">
          <i class="material-icons text-sm">phone</i> {{ phone }}
        </span>
        <span class="flex items-center gap-1">
          <i class="material-icons text-sm">email</i> {{ email }}
        </span>
      </div>
      <div class="flex items-center gap-4">
        <div class="flex gap-2">
          <a
            v-for="social in socials"
            :key="social.icon"
            :href="social.link"
            class="hover:text-primary"
          >
            <i class="material-icons text-sm">{{ social.icon }}</i>
          </a>
        </div>
        <!-- <div
          class="border-l dark:border-slate-700 pl-4 flex items-center gap-1 cursor-pointer group"
        >
          <span class="uppercase group-hover:text-primary transition-colors"
            >English</span
          >
          <i class="material-icons text-sm">expand_more</i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    phone: { type: String, default: '+86 139 2377 6251' },
    email: { type: String, default: 'sales@hdsilicone.com' }
  },
  data() {
    return {
      socials: [
        { icon: 'facebook', link: '#' },
        { icon: 'share', link: '#' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/Topbar.vue